import React from 'react';
import { useTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import { Icon } from '@dnb/eufemia/components';
import { information_bubble } from '@dnb/eufemia/icons';
import './planned-incidents.css';
import PlannedIncidentItem from './PlannedIncidentItem';

const PlannedIncidents = ({ maintenances, includedComponents }) => {
  const { t } = useTranslation();
  
  const renderContent = () => {
    const maintenancesList = maintenances
      .filter((e) => {
        if (e.components.length > 0) {
          if (e.components[0].id in includedComponents) {
            return e;
          }
        } else {
          return e;
        }
      });
    if (maintenancesList.length > 0) {
      return (
        <ul className='dnb-planned-incidents' style={{ width: '100%', maxWidth: '100%' }}>
          {maintenancesList.map((maintenance) => {
            return <PlannedIncidentItem key={maintenance.id} item={maintenance} />;
          })}
        </ul>
      );
    } else {
      return (
        <div className='dnb-planned-incidents__no-incidents'>
          <div>
            <Icon icon={information_bubble} size="medium" />
            <p>{t('There is currently no scheduled maintenance')}.</p>
          </div>
        </div>
      );
    }
  };

  return (
    <div className='dnb-planned-incidents-wrapper' style={{ width: '100%', maxWidth: '100%' }}>
      <h2 className='dnb-planned-incidents__heading'>{t('Scheduled maintenance')}</h2>
      {renderContent()}
    </div>
  );
};

export default PlannedIncidents;

PlannedIncidents.propTypes = {
  maintenances: PropTypes.array,
  includedComponents: PropTypes.object
};
